<template>
  <v-flex
    xs12
    >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm12
        md5
      >
        <h3>
          URL of the post
        </h3>
        <v-flex
          xs12
        >
          <v-text-field
            placeholder="https://www.facebook.com/democrats/"
            v-model="url"
            prepend-icon="link"
          ></v-text-field>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex'
import Adcreatives from '../../../../../facebook/Adcreatives'
import helpers from '../../../../../helpers/functions'
export default {
  name: 'promote-post-top-block',
  data () {
    return {
      url: '23842817641480384',
      timeout: null
    }
  },
  props: {
    reviewFileUrl: {
      type: String,
      default: null
    }
  },
  methods: {
    scrapUrl () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let user = helpers.getCurrentUser()
        const creative = new Adcreatives(user, {adcreative_id: this.url})
        new Promise(resolve => {
          resolve(creative.getAdCreativeById())
        })
          .then(res => {
            const objectStorySpec = res.object_story_spec
            const storySpecFields = {}
            if (objectStorySpec) {
              const keys = Object.keys(res.object_story_spec)
              const types = ['link_data', 'video_data']
              const objectType = types.find(t => t === keys.find(k => k === t))
              storySpecFields.description = objectStorySpec[objectType].message || ''
              storySpecFields.link = objectStorySpec[objectType].link || ''
              storySpecFields.headline = objectStorySpec[objectType].name || ''
              storySpecFields.image_url = objectStorySpec[objectType].image_url || null
              storySpecFields.image_hash = objectStorySpec[objectType].image_hash || null
            }
            this.$emit('setMessageFields', storySpecFields.image_url, 'externalUrl')
            this.$emit('setMessageFields', storySpecFields.image_hash, 'image_hash')
            this.$emit('setMessageFields', res.call_to_action_type.split('_').join(' '), 'callToAction')
            this.$emit('setMessageFields', storySpecFields.description, 'description')
            this.$emit('setMessageFields', storySpecFields.link, 'link')
            this.$emit('setMessageFields', storySpecFields.headline, 'headline', true)
          })
      }, 1000)
    },
    ...mapActions([
      'showNotification'
    ])
  },
  watch: {
    url: {
      handler (val) {
        this.scrapUrl()
      },
      immediate: true
    }
  }
}
</script>
<style>
  .preview-img {
    width: 300px;
    height: auto;
    overflow: hidden;
    position: relative;
  }
  img {
    object-position: top center;
    object-fit: cover;
  }
  .green-circle {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #4caf50;
    margin-bottom: 1px;
  }
  .component-fade-enter-active {
    transition: transform .3s ease;
  }
  .component-fade-enter {
    transform: translateY(200px);
  }
</style>
